<!--TODO add skeleton-->
<template>
  <BannerSlider class="bannerSliderWrapper" :items-length="bannerItems.length">
    <template v-slot:content="{ currentIndex }">
      <BannerSliderItem
        v-for="(item, index) in bannerItems"
        :key="index"
        v-show="currentIndex === index"
        :item="item"
      >
        <a :href="item.url" target="_blank">
          <img class="bannerSlider_image" :src="item.imageUrl.replace('{0}', '286_190')" />
        </a>
        <h2 class="bannerSlider_title" v-html="item.title" />
        <p
          class="bannerSlider_description"
          :class="{
            bannerSlider_description_noButton: !item.buttonText,
          }"
          v-html="item.description"
        />
        <button
          v-if="item.buttonText"
          @click="() => clickHandler(item.url)"
          v-html="item.buttonText"
          type="button"
          class="bannerSlider_button"
        />
      </BannerSliderItem>
    </template>
  </BannerSlider>
</template>

<script>
import { BannerSlider, BannerSliderItem } from '@n11/so-ui-components';

export default {
  name: 'DashboardRightFirstBanner',
  components: {
    BannerSlider,
    BannerSliderItem,
  },
  props: {
    bannerItems: {
      type: Array,
      required: true,
    },
  },
  methods: {
    clickHandler(url) {
      window.location = url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.bannerSlider {
  &_image {
    border-radius: 8px;
    width: 100%;
    height: 190px;
    object-fit: cover;
  }

  &_title {
    width: 250px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.25;
    color: $colorN00;
    position: absolute;
    bottom: 32px;
    left: 12px;
    text-shadow: 1px 1px black;
    float: right;
  }

  &_description {
    width: 175px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.25;
    color: $colorN00;
    position: absolute;
    bottom: 10px;
    left: 12px;
    text-shadow: 1px 1px black;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &_noButton {
      width: 250px;
    }
  }

  &_button {
    width: 85px;
    border-radius: 6px;
    background-color: $blue-9;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: -0.09px;
    color: $colorN00;
    position: absolute;
    bottom: 7px;
    right: 12px;
    float: right;
    border: none;
    padding: 5px;
  }

  &_button:active {
    transform: translateY(1px);
  }

  &_button:focus {
    outline: none;
  }
}
</style>
